import React from "react";
import "./style.css";
import { useTranslation } from "react-i18next";

// Import Swiper React components
import { Swiper, SwiperSlide } from "swiper/react";
import { Autoplay, Pagination, Navigation } from "swiper/modules";

// Import Swiper styles
import "swiper/css";
import "swiper/css/pagination";
import "swiper/css/navigation";

const LifeGallery = () => {
  const { t } = useTranslation("lifeAtBitsclan");

  const lifeGallery = t("lifeGallery", { returnObjects: true });

  // Collect all images here
  const galleryImages = [
    "/images/life-at-bitsclan/team-usa2.avif",
    "/images/life-at-bitsclan/life-image-2.avif",
    "/images/life-at-bitsclan/team-usa4.avif",
    "/images/life-at-bitsclan/team-usa3.avif",
    "/images/life-at-bitsclan/team-usa5.avif",
  ];

  return (
    <div className="ceo-intro-main-box meet-our-team-box">
      <div className="container">
        <div className="row mb-5">
          <div className="col-md-12 text-center">
            <h1 className="main-heading">{lifeGallery.heading}</h1>
            <h3 className="sub-heading">{lifeGallery.subHeading}</h3>
          </div>
        </div>

        <Swiper
          slidesPerView={'1.5'}
          spaceBetween={30}
          centeredSlides={true}
          loop={true}
          autoplay={{
            delay: 2500,
            disableOnInteraction: false,
          }}
          pagination={{ clickable: true }}
          navigation={false}
          breakpoints={{
            0: {
              slidesPerView: 1, // 👈 for mobile
            },
            768: {
              slidesPerView: 1.5, // 👈 tablet & up
            },
          }}
          modules={[Autoplay, Pagination, Navigation]}
          className="life-gallery-swiper"
        >
          {galleryImages.map((src, index) => (
            <SwiperSlide key={index}>
              <div className="life-image-slider">
                <img src={src} alt={`Life At Bitsclan ${index + 1}`} />
              </div>
            </SwiperSlide>
          ))}
        </Swiper>
      </div>
    </div>
  );
};

export default LifeGallery;